import 'typeface-roboto';
import './styles/App.css';

import {
  ApolloClient,
  ApolloProvider,
  NormalizedCacheObject
} from '@apollo/client';
import {
  Navigate,
  Outlet,
  Route,
  RouterProvider,
  Routes,
  createBrowserRouter,
  createRoutesFromElements,
  useLocation,
  useNavigate
} from 'react-router-dom';
import { Tab, Tabs } from '@mui/material';

import ApolloClientService from '../shared/services/ApolloClientService';
import Config from '../shared/config';
import CourseRoutes from './components/CourseRoutes';
import Grid from '@mui/material/Unstable_Grid2';
import { Page404 } from '../shared/components/Page404';
import React from 'react';
import User from '../membership/models/User';
import UserAccount from './components/UserAccount';
import UserProgress from './components/UserProgress';
import WithTheming from './components/WithTheming';

let apolloClient: ApolloClient<NormalizedCacheObject> = null;

const DASHBOARD_TABS = [
  { label: 'Courses', route: '/dashboard/course' },
  { label: 'Account', route: '/dashboard/account' },
  { label: 'Progress', route: '/dashboard/progress' }
];
export interface DashboardProps {
  user: User;
}

const App = (props: DashboardProps) => {
  if (apolloClient === null) {
    apolloClient = ApolloClientService.create(Config.DASHBOARD_GQL);
  }

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleChange = (_: React.ChangeEvent<{}>, value: string) => {
    navigate(value);
  };

  return props.user ? (
    <ApolloProvider client={apolloClient}>
      <WithTheming>
        <>
          <Grid container direction="column" spacing={2}>
            <Grid container justifyContent="center">
              {DASHBOARD_TABS.some((tab) => tab.route === pathname) && (
                <Tabs value={pathname} onChange={handleChange}>
                  {DASHBOARD_TABS.map((tab) => (
                    <Tab key={tab.label} label={tab.label} value={tab.route} />
                  ))}
                </Tabs>
              )}
            </Grid>
            <Grid className="dashboard-content">
              <Routes>
                <Route index element={<Navigate to="/dashboard/course" />} />
                <Route path={'course/*'} element={<CourseRoutes />} />
                <Route path={'account'} element={<UserAccount />} />
                <Route path={'progress'} element={<UserProgress />} />
                <Route path="*" element={<Page404 />} />
              </Routes>
            </Grid>
          </Grid>
        </>
      </WithTheming>
    </ApolloProvider>
  ) : (
    <p>Loading...</p>
  );
};

export default App;
